export default __webpack_public_path__ + "static/media/google-play.420506f6.svg";